export default __webpack_public_path__ + "static/3-96b4b497d2999c146cc3b5240412660f.jpeg";